import React from 'react';
import { Header, Footer } from '../../component/index';

const Features = () => {
    return (
        <>
        <Header homepage={false} />
        <div className="wrapper">
            <div className="container-w-lg">
                <div className="row">
                    <img src="static/images/img_banner_features.png" alt="features" width="100%"/>
                </div>
            </div>
            <div className="container-fluid m-b-50">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="page-title-box p-0 m-t-50">
                            <h4 className="page-title mb-10">Features</h4>
                        </div>
                    </div>
                </div>
                <div className="flex-container">
                    <div className="row">
                        <div className="title_underline"></div>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <h4 className="header-title-sm font-16">Digitize and sharing cards in company</h4>
                </div>
                <div className="row m-t-50">
                    <div className="col-sm-12 col-md-6">
                        <div className="features-card card-box">
                            <div className="features-box">
                                <img src="static/images/ic_features.svg" alt="features" className="features-logo"/>
                                <h4 className="features-title">Digitize business cards in multiple languages</h4>
                            </div>
                            <div className="clearfix"></div>
                            <p className="features-content">Sansan’s core feature. Simply scan in business cards received by anyone at your company, to collate into a complete cloud-based directory, ready for you to access anytime, anywhere. Make the most of every connection, and every opportunity. The following languages can be transcribed: English, German, French, Japanese, Chinese, Korean, Spanish, Portuguese, Thai, Indonesian.</p>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                        <div className="features-card card-box">
                            <div className="features-box">
                                <img src="static/images/ic_features.svg" alt="features" className="features-logo"/>
                                <h4 className="features-title">Intuitive user interface design</h4>
                            </div>
                            <div className="clearfix"></div>
                            <p className="features-content">Sansan’s core feature. Simply scan in business cards received by anyone at your company, to collate into a complete cloud-based directory, ready for you to access anytime, anywhere. Make the most of every connection, and every opportunity. The following languages can be transcribed: English, German, French, Japanese, Chinese, Korean, Spanish, Portuguese, Thai, Indonesian.</p>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                        <div className="features-card card-box">
                            <div className="features-box">
                                <img src="static/images/ic_features.svg" alt="features" className="features-logo"/>
                                <h4 className="features-title">Build a private cloud with WorldCard Team</h4>
                            </div>
                            <div className="clearfix"></div>
                            <p className="features-content">Sansan’s core feature. Simply scan in business cards received by anyone at your company, to collate into a complete cloud-based directory, ready for you to access anytime, anywhere. Make the most of every connection, and every opportunity. The following languages can be transcribed: English, German, French, Japanese, Chinese, Korean, Spanish, Portuguese, Thai, Indonesian.</p>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                        <div className="features-card card-box">
                            <div className="features-box">
                                <img src="static/images/ic_features.svg" alt="features" className="features-logo"/>
                                <h4 className="features-title">Automatic data synchronization between smartphone and PC</h4>
                            </div>
                            <div className="clearfix"></div>
                            <p className="features-content">Sansan’s core feature. Simply scan in business cards received by anyone at your company, to collate into a complete cloud-based directory, ready for you to access anytime, anywhere. Make the most of every connection, and every opportunity. The following languages can be transcribed: English, German, French, Japanese, Chinese, Korean, Spanish, Portuguese, Thai, Indonesian.</p>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                        <div className="features-card card-box">
                            <div className="features-box">
                                <img src="static/images/ic_features.svg" alt="features" className="features-logo"/>
                                <h4 className="features-title">Contacts are centrally managed and ermanently stored in the company database</h4>
                            </div>
                            <div className="clearfix"></div>
                            <p className="features-content">Sansan’s core feature. Simply scan in business cards received by anyone at your company, to collate into a complete cloud-based directory, ready for you to access anytime, anywhere. Make the most of every connection, and every opportunity. The following languages can be transcribed: English, German, French, Japanese, Chinese, Korean, Spanish, Portuguese, Thai, Indonesian.</p>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                        <div className="features-card card-box">
                            <div className="features-box">
                                <img src="static/images/ic_features.svg" alt="features" className="features-logo"/>
                                <h4 className="features-title">Digitize business cards in multiple languages</h4>
                            </div>
                            <div className="clearfix"></div>
                            <p className="features-content">Sansan’s core feature. Simply scan in business cards received by anyone at your company, to collate into a complete cloud-based directory, ready for you to access anytime, anywhere. Make the most of every connection, and every opportunity. The following languages can be transcribed: English, German, French, Japanese, Chinese, Korean, Spanish, Portuguese, Thai, Indonesian.</p>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                        <div className="features-card card-box">
                            <div className="features-box">
                                <img src="static/images/ic_features.svg" alt="features" className="features-logo"/>
                                <h4 className="features-title">Share business cards among colleagues and create sustainable network of contacts</h4>
                            </div>
                            <div className="clearfix"></div>
                            <p className="features-content">Sansan’s core feature. Simply scan in business cards received by anyone at your company, to collate into a complete cloud-based directory, ready for you to access anytime, anywhere. Make the most of every connection, and every opportunity. The following languages can be transcribed: English, German, French, Japanese, Chinese, Korean, Spanish, Portuguese, Thai, Indonesian.</p>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-6">
                        <div className="features-card card-box">
                            <div className="features-box">
                                <img src="static/images/ic_features.svg" alt="features" className="features-logo"/>
                                <h4 className="features-title">Digitize business cards in multiple languages</h4>
                            </div>
                            <div className="clearfix"></div>
                            <p className="features-content">Sansan’s core feature. Simply scan in business cards received by anyone at your company, to collate into a complete cloud-based directory, ready for you to access anytime, anywhere. Make the most of every connection, and every opportunity. The following languages can be transcribed: English, German, French, Japanese, Chinese, Korean, Spanish, Portuguese, Thai, Indonesian.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="above-footer"></div>
        </div>
        <Footer/>
        </>
    )
}

export default Features;